<!-- <mat-selection-list #shoes [multiple]="false">
<mat-list-option *ngFor="let item of menuItems let i = index" [selected]="item && i == 0" [value]="item" >
    <div style="display: flex;" routerLink="{{item.path}}" class="test"  routerLinkActive="active">
      <mat-icon>{{item.icon}}</mat-icon>&nbsp; {{item.title}}
    </div>
  </mat-list-option>
</mat-selection-list> -->

<div class="sidebar">
  <a
    *ngFor="let item of menuItems; let i = index"
    (click)="manageSettingClick(item.path)"
    routerLink="{{ item.path }}"
    routerLinkActive="active"
    class="d-flex align-content-center"
  >
   <mat-icon class="d-flex"
        ><img
        class="sidenavioss"
          [src]="item.icon"
          style="
            height: 24px !important;
            width: 24px !important;
            margin-top: 0;
          " /></mat-icon
    >
    <span style="padding-left: 10px">{{ item.title }}</span>
  </a>
</div>
